import {
  formatEventDateParts,
  formatEventTime,
  formatSpan,
  googleCalendarUrl,
} from "src/lib/events";

import styles from "@/styles/Events.module.css";

/**
 * `showDay` is on in the upcoming agenda, where the list mixes dates, and off
 * when the heading above already names the day — so the date column only
 * renders when the row actually needs to carry that information.
 */
function EventCard({ event, showDay }) {
  const span = formatSpan(event);
  const dateParts = showDay ? formatEventDateParts(event) : null;

  return (
    <li className={styles.eventCard}>
      {dateParts && (
        <div className={styles.eventDate}>
          <span className={styles.eventWeekday}>{dateParts.weekday}</span>
          <span className={styles.eventDayNum}>{dateParts.day}</span>
          <span className={styles.eventMonth}>{dateParts.month}</span>
        </div>
      )}

      <div className={styles.eventMain}>
        <div className={styles.eventMeta}>
          <span className={styles.eventTime}>{formatEventTime(event)}</span>
          {span && (
            <>
              <span className={styles.eventMetaSep}>·</span>
              <span className={styles.eventDetail}>{span}</span>
            </>
          )}
          {event.location && (
            <>
              <span className={styles.eventMetaSep}>·</span>
              <span className={styles.eventDetail}>{event.location}</span>
            </>
          )}
        </div>

        <h3 className={styles.eventTitle}>{event.title}</h3>

        {event.description && (
          <div
            className={styles.eventDescription}
            // Descriptions are written by station staff in Google Calendar and
            // arrive as HTML, same as our CMS copy.
            dangerouslySetInnerHTML={{ __html: event.description }}
          />
        )}
      </div>

      <div className={styles.actionRow}>
        {event.htmlLink && (
          <a
            href={event.htmlLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.actionIconBtn}
            title="Details"
            aria-label="Details"
          >
            <svg
              className={styles.actionIcon}
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <path d="M15 3h6v6" />
              <path d="M10 14 21 3" />
            </svg>
          </a>
        )}
        <button
          type="button"
          className={styles.actionIconBtn}
          title="Add to calendar"
          aria-label="Add to calendar"
          onClick={() =>
            window.open(googleCalendarUrl(event), "_blank", "noopener")
          }
        >
          <svg
            className={styles.actionIcon}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <path d="M3 10h18" />
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <path d="M12 14v5" />
            <path d="M9.5 16.5h5" />
          </svg>
        </button>
      </div>
    </li>
  );
}

export default EventCard;
